<div>
    <app-current-weather></app-current-weather>
    <app-loading></app-loading>
    <app-forecast></app-forecast>
    <app-geolocation-button></app-geolocation-button>    
</div>
